<template>
  <div class="game-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-input v-model="searchName" placeholder="游戏名称" clearable class="filter-input" @keyup.enter.native="handleSearch" />
            <el-select v-model="searchStatus" placeholder="状态" clearable class="filter-select-sm" @change="handleSearch">
              <el-option label="上架" :value="1" />
              <el-option label="下架" :value="0" />
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
          </div>
          <div class="action-group">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增游戏</el-button>
            <el-button type="warning" icon="el-icon-connection" @click="$router.push('/leader-game')">创作者游戏分配</el-button>
          </div>
        </div>
      </div>

      <el-table :data="list" border stripe v-loading="loading" row-key="id">
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="name" label="名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="图标" width="100" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.icon" :src="scope.row.icon" style="width:56px;height:56px" fit="contain" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.status === 1 ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="170" align="center" />
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" center append-to-body>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model.trim="form.name" maxlength="100" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图标">
          <el-upload action="#" :auto-upload="false" :show-file-list="false" accept="image/*" :on-change="handleIconChange">
            <el-button size="small" type="primary">选择图片</el-button>
          </el-upload>
          <div v-if="iconPreview" class="icon-preview">
            <el-image :src="iconPreview" style="width:60px;height:60px" fit="contain" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, del, BASE_URL } from '@/utils/http'

export default {
  name: 'GameManagement',
  data() {
    return {
      list: [],
      loading: false,
      submitting: false,
      searchName: '',
      searchStatus: '',
      pagination: { page: 1, pageSize: 10, total: 0 },
      dialogVisible: false,
      isEdit: false,
      editId: null,
      iconFile: null,
      iconPreview: '',
      form: { name: '', status: 1 },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑游戏' : '新增游戏'
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const params = { page: this.pagination.page, pageSize: this.pagination.pageSize }
        if (this.searchName) params.name = this.searchName
        if (this.searchStatus !== '' && this.searchStatus !== null) params.status = this.searchStatus
        const result = await get('/admin/game/list', params)
        const data = result.data || {}
        this.list = Array.isArray(data.records) ? data.records : []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    refreshList() {
      this.searchName = ''
      this.searchStatus = ''
      this.pagination.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    },
    handleAdd() {
      this.isEdit = false
      this.editId = null
      this.iconFile = null
      this.iconPreview = ''
      this.form = { name: '', status: 1 }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.iconFile = null
      this.iconPreview = row.icon || ''
      this.form = { name: row.name, status: row.status != null ? row.status : 1 }
      this.dialogVisible = true
    },
    handleIconChange(file) {
      this.iconFile = file.raw
      this.iconPreview = URL.createObjectURL(file.raw)
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()
      } catch {
        return
      }
      this.submitting = true
      try {
        const formData = new FormData()
        formData.append('name', this.form.name)
        formData.append('status', this.form.status)
        if (this.iconFile) formData.append('iconFile', this.iconFile)

        const token = localStorage.getItem('token')
        const url = this.isEdit ? `${BASE_URL}/admin/game/${this.editId}` : `${BASE_URL}/admin/game`
        const response = await fetch(url, {
          method: this.isEdit ? 'PUT' : 'POST',
          headers: { ...(token && { token }) },
          body: formData
        })
        const result = await response.json()
        if (result.code === 200 || result.code === 1) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.fetchList()
        } else {
          throw new Error(result.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.submitting = false
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该游戏吗？', '提示', { type: 'warning' })
        await del(`/admin/game/${row.id}`)
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {
        if (e !== 'cancel') this.$message.error(e.message || '删除失败')
      }
    }
  }
}
</script>

<style scoped>
.pagination-container { margin-top: 16px; text-align: right; }
.icon-preview { margin-top: 8px; }
</style>
